import { useState } from 'preact/hooks';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '@/state/config.js';

/** Renders nothing when the account has no questions — there is no enable flag. */
export function FaqSection() {
  const items = faqs.value;
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  if (items.length === 0) return null;

  return (
    <section className="sm-stack sm-faq" aria-labelledby="sm-faq-heading">
      <h2 className="sm-type-heading" id="sm-faq-heading">
        Frequently asked questions
      </h2>

      <div className="sm-stack sm-faq-list">
        {items.map((item, i) => (
          // Index keys: the list is fixed per config load, and two questions can legitimately match.
          <div className="sm-faq-item" key={i}>
            <button
              type="button"
              className="sm-summary-row sm-faq-question"
              aria-expanded={openIndex === i}
              onClick={() => setOpenIndex(openIndex === i ? null : i)}
            >
              <span className="sm-type-body-strong sm-faq-question-text">{item.question}</span>
              <ChevronDownIcon className="sm-chevron" size={18} aria-hidden="true" />
            </button>

            {openIndex === i && (
              <div className="sm-faq-answer">
                <p className="sm-type-body sm-muted">{item.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
